function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 12L9.46 9.46a.996.996 0 00-1.41 0L6.21 11.3a.996.996 0 000 1.41l1.84 1.84c.39.39 1.02.39 1.41 0l5.09-5.09a.996.996 0 011.41 0l1.84 1.84c.39.39.39 1.02 0 1.41l-1.84 1.84a.996.996 0 01-1.41 0L12 12z"
})));